import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import updateLocale from 'dayjs/plugin/updateLocale';
import duration from 'dayjs/plugin/duration';
import 'dayjs/locale/fr';
import { AGE_ADULT, AGE_LIMITE_ADULT_TEETH, MIN_AGE_EMANCIPATION } from '../global/constants';
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(updateLocale);
dayjs.extend(duration);
dayjs.updateLocale('fr', {
    months: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre'
    ]
});
export var UnitEnum;
(function (UnitEnum) {
    UnitEnum["MILLISECONDS"] = "ms";
    UnitEnum["SECOND"] = "second";
    UnitEnum["MINUTE"] = "minute";
    UnitEnum["QUARTER"] = "quarter";
    UnitEnum["HOUR"] = "hour";
    UnitEnum["DAYS"] = "day";
    UnitEnum["WEEK"] = "week";
    UnitEnum["MONTHS"] = "month";
    UnitEnum["YEARS"] = "year";
})(UnitEnum || (UnitEnum = {}));
export const formatDate = (date, format = DateFormats.DAY_MONTH_YEAR) => {
    if (date) {
        return dayjs(date).locale('fr').format(format);
    }
    return null;
};
export const dateToString = (date, format = DateFormats.DAY_MONTH_YEAR) => {
    if (!date)
        return null;
    return dayjs(date).locale('fr').format(format);
};
export const stringDateToMs = (date) => {
    if (!date)
        return null;
    let dateToFormat = date;
    if (dayjs(date, DateFormats.DAY_MONTH_YEAR).isValid()) {
        dateToFormat = dayjs(date, DateFormats.DAY_MONTH_YEAR, 'fr').format(DateFormats.YEAR_MONTH_DAY);
    }
    const msDate = dayjs(dateToFormat).valueOf();
    if (!msDate)
        return -1;
    return msDate;
};
export const getToday = (format = DateFormats.DAY_MONTH_YEAR_HOUR_MIN_SEC) => {
    return dayjs().format(format);
};
export const yearDiffToday = (date) => {
    const formattedDate = dayjs(date, DateFormats.DAY_MONTH_YEAR, 'fr').format(DateFormats.YEAR_MONTH_DAY);
    const today = dayjs();
    return today.diff(formattedDate, 'year');
};
export const parseDate = (date) => {
    if (!date)
        return null;
    const parseDate = dayjs.utc(date, DateFormats.DAY_MONTH_YEAR).format();
    return new Date(parseDate);
};
export const parseLucieDate = (date) => {
    if (!date) {
        return new Date();
    }
    if (date.includes(' ')) {
        const dateSplitted = date.split(' ');
        const year = +dateSplitted[4];
        const month = +dateSplitted[2] - 1;
        const day = +dateSplitted[0];
        return new Date(year, month, day);
    }
    return new Date();
};
export const getDiffBetween = (date1, date2, unit = UnitEnum.MILLISECONDS) => {
    if (!date1 || !date2)
        return null;
    return dayjs(parseDate(date1)).diff(parseDate(date2), unit);
};
export const getDateInFuture = (date, duration) => {
    return dayjs(parseDate(date)).add(duration, 'day').format(DateFormats.DAY_MONTH_YEAR);
};
export const hasAdultTeeth = (birth) => {
    const today = dateToString(new Date());
    return getDiffBetween(today, birth, UnitEnum.YEARS) > AGE_LIMITE_ADULT_TEETH;
};
export const getAge = (birthDate, today) => {
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
};
export const isAdult = (date, today) => {
    if (!date)
        return null;
    const age = getAge(parseDate(date), today);
    return age >= AGE_ADULT;
};
export const isOverOrEqualEmancipationAge = (date, today) => {
    if (!date || !today)
        return null;
    const age = getAge(parseDate(date), today);
    return age >= MIN_AGE_EMANCIPATION;
};
export var DateFormats;
(function (DateFormats) {
    DateFormats["MONTH_FULL_LETTERS"] = "MMMM";
    DateFormats["YEAR_FULL_DIGITS"] = "YYYY";
    DateFormats["DAY_MONTH_YEAR"] = "DD/MM/YYYY";
    DateFormats["YEAR_MONTH_DAY"] = "YYYY-MM-DD";
    DateFormats["DAY_MONTH_YEAR_HOUR_MIN_SEC"] = "DD/MM/YYYY HH:mm:ss";
})(DateFormats || (DateFormats = {}));
